import React from 'react'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import TextField from '@material-ui/core/TextField'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#03B0EE',
      contrastText: '#FFF',
    },
  },
  typography: { useNextVariants: true },
})

export default props => (
  <ThemeProvider theme={theme}>
    <TextField {...props}/>
  </ThemeProvider>
)
